// @ts-ignore
/* eslint-disable */
import axios from 'axios';
import { request } from '../axios/sdpPro';


/** 这是一个特殊的服务，是网关直接暴露的接口，没有 swagger 文档，所以所有代码是手写的，不是自动生成 */

/** 获取首页 了解我们的SaaS产品 内容 */
export async function getSassContents(
  params?: {},
  options?: { [key: string]: any },
) {
  return request<APISdpPro.HomePage>('/api/common/system/homePage', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}



/** 获取首页 公告 内容 */
export async function getSassNotices(
  params?: {},
  options?: { [key: string]: any },
) {
  return request<APISdpPro.Notices>('/api/common/system/notice', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}



export async function getUrlInfos(
  params?: {},
  options?: { [key: string]: any },
): Promise<{
  casUtl: string
  pgeRZDataB: string
  pgeRZRandNum: string
  sdpproUrl: string
}> {
  return request('/api/common/urlInfo', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  })
}


export async function statusBusinessType(
  params?: {},
  options?: { [key: string]: any },
) {
  return request('/api/status/business/type', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  })
}


export async function loginpwdWhichVerify(
  params?: {},
  options?: { [key: string]: any },
) {
  return axios('/reset/loginpwd/whichVerify', {
    baseURL: 'http://sassbff.sdptest.shengpay.com',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  }).then<{
    type: 1 | 2 | 0 //1:简单类型 2:复杂类型 0:不需要
  }>(res => res?.data)
}

